import constants from 'constants/index'

const processChipStatusBgColor = (status) => {
  return (
    (status &&
      constants.audits.DATA_PROCESS_CHIP_STATUS_BACKGROUND_COLOR[status]) ||
    undefined
  )
}

export default processChipStatusBgColor
